import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ReportProblemOutline from '@material-ui/icons/ReportProblemOutlined';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ArrangementsHelpButton extends React.Component {
  render() {
    const { classes, action } = this.props;
    const stringsComponent = 'arrangements';

    return (
      <React.Fragment>
        <Button
          className={classes.button}
          variant="text"
          mini={true}
          color="primary"
          onClick={action}
        >
          <ReportProblemOutline />
          <Typography>
            <VisuallyHidden
              body={getString(
                stringsComponent,
                'ARRANGEMENT_DIALOG_DEBT_TITLE'
              )}
            />
          </Typography>
        </Button>
      </React.Fragment>
    );
  }
}

ArrangementsHelpButton.propTypes = {
  classes: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
};

ArrangementsHelpButton.defaultProps = {};

export default withStyles(styles)(ArrangementsHelpButton);
